<template>
  <div style="max-width: 500px; margin-right: auto; margin-left: auto">
    <Plants />
    <Sharings />
  </div>
</template>

<script>
import Plants from "@/components/garden/Plants.vue";
import Sharings from "@/components/garden/Sharings.vue";

export default {
  components: {
    Plants,
    Sharings,
  },
  mounted() {
    this.$store.dispatch("gardens/getGarden");
  },
  watch: {
    "$route.params.gardenId": {
      handler: function (val) {
        if (val) {
          this.$store.dispatch(`users/getUser`, val);
          this.$store.dispatch(`plants/getPlants`, val);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style >
</style>